import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import SwitchOnKitSectionHeader from "./SwitchOnKitSectionHeader";

// Adapted from ITEModel: processors occupy the model step for this builder.
const SwitchOnKitProcessor = ({ rightSelected, leftSelected, linked, setLinked, getOptionsForSide, allowedValues, selectedOptions, setOption, getSideItem }) => {
  const renderSide = (side) => {
    const option = getOptionsForSide(side).find((entry) => entry.Code === "AB_PROCESSOR");
    if (!option) return null;
    return allowedValues(option, side).map((value) => {
      const active = selectedOptions[side][option.Name] === value;
      const imagePath = getSideItem(side) && getSideItem(side).ImagePath;
      return <button type="button" className="switch-on-kit-processor-button" key={value} aria-pressed={active} onClick={() => setOption(side, option, value)}>
        <div className={`ite-model-box ${active ? "active" : ""}`}><Row>
          <Col xs={2}><div className="ite-model-box-image">{imagePath && <img src={imagePath} className="img-fluid" alt="" />}</div></Col>
          <Col xs={8}><div className="ite-model-box-text"><p>{value}</p></div></Col>
          <Col xs={2}><div className="active-tick"></div></Col>
        </Row></div>
      </button>;
    });
  };

  return <div className="switch-on-kit-option-section ite-model-component-main-div">
    <SwitchOnKitSectionHeader title="Choose a speech processor" rightSelected={rightSelected} leftSelected={leftSelected} linked={linked} setLinked={setLinked}>
      <Col md={6}><div className="ite-model-row-right">{rightSelected && renderSide("R")}</div></Col>
      <Col md={6} className="left-side"><div className="ite-model-row-left">{leftSelected && renderSide("L")}</div></Col>
    </SwitchOnKitSectionHeader>
  </div>;
};

SwitchOnKitProcessor.propTypes = {
  rightSelected: PropTypes.bool, leftSelected: PropTypes.bool, linked: PropTypes.bool, setLinked: PropTypes.func,
  getOptionsForSide: PropTypes.func, allowedValues: PropTypes.func, selectedOptions: PropTypes.object,
  setOption: PropTypes.func, getSideItem: PropTypes.func,
};
export default SwitchOnKitProcessor;
